import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
};
export const watchingFrequencyTime = 10000;

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(function(user) {
  // Once authenticated, instantiate Firechat with the logged in user
  if (user) {
    console.log("[Auth] On auth state changed : ", user);
  }
});
export const db = firebase.database();
export async function logout() {
  try {
    const user = firebase.auth().currentUser;
    if (user) {
      const email = localStorage.getItem("email");
      var uid = firebase.auth().currentUser.uid;
      await setDbFields(uid, { signedIn: false, email });
      await firebase.auth().signOut();
    }
    localStorage.clear();
    return Promise.resolve();
  } catch (error) {
    console.log(error);
    throw new Error(error.toString());
  }
}

export function getRole() {
  try {
    console.log("[auth] get user role for authorization");
    const role = localStorage.getItem("role");
    return role ? Promise.resolve(role) : Promise.reject();
  } catch (error) {
    console.log(error.toString());
    throw new Error(error.toString());
  }
}

export async function forgotPassword({ email }) {
  try {
    console.log("request to reset password - email : ", email);
    await firebase.auth().sendPasswordResetEmail(email);
    return Promise.resolve();
  } catch (error) {
    var errorCode = error.code;
    if (errorCode === "auth/invalid-email") {
      throw new Error("Please enter valid email address");
    } else if (errorCode === "auth/user-not-found") {
      throw new Error(
        "Your not authorized to access this domain. Please contact contact.omswami@gmail.com"
      );
    }
    console.log(error.toString());
    throw new Error(error.toString());
  }
}

// --------------------------------

export const authorize = async ({ email, password }) => {
  try {
    console.log("[auth] request to login email : ", email);
    await firebase.auth().signInWithEmailAndPassword(email, password);
    localStorage.setItem("email", email);
    sessionStorage.setItem("email", email);
  } catch (error) {
    console.log("error in firebase index.js authorize ", error.toString());
    throw new Error(error.toString());
  }
};
export const unAuthorize = async () => {
  localStorage.clear();
  sessionStorage.clear();
  await firebase.auth().signOut();
};
export const checkDbStatus = async () => {
  try {
    var uid = firebase.auth().currentUser.uid;
    const email = localStorage.getItem("email");
    const data = await getDbFields(uid);
    if (!data) {
      // if not exists --> setting
      await setDbFields(uid, { email, signedIn: true });
      return ""; // just to stop flow
    }
    if (data.signedIn) return "AUTH_ACTIONS.ALREADY_LOGED_IN";

    await setDbFields(uid, { email, signedIn: true });
  } catch (error) {
    console.log(" error ", error.toString());
    return "AUTH_ACTIONS.UN_AUTHORIZED_USER";
  }
};

export const checkLocalStorageStatus = async () => {
  try {
    console.log(" session storage email ", sessionStorage.getItem("email"));
    console.log(" localStorageStatus() email ", localStorage.getItem("email"));
    console.log(" localStorageStatus() role ", localStorage.getItem("role"));
    const user = firebase.auth().currentUser; //.getIdTokenResult();
    if (user) {
      console.log(" user authorized from firebase ", user);
      const email = user.email;
      localStorage.setItem("email", email);
      const data = await user.getIdTokenResult();
      const role = data.claims.role || "NONE";
      localStorage.setItem("token", data.token);
      localStorage.setItem("role", role);
      return;
    }
    if (!localStorage.getItem("email"))
      return "AUTH_ACTIONS.UN_AUTHORIZED_USER";
    if (!sessionStorage.getItem("email"))
      return "AUTH_ACTIONS.UN_AUTHORIZED_USER";
  } catch (error) {
    console.log("in catch() ", error.toString());
    return "AUTH_ACTIONS.UN_AUTHORIZED_USER";
  }
};

export const watchDbStatus = async () => {
  const uid = firebase.auth().currentUser.uid;
  const data = await getDbFields(uid);
  console.log(" data in watchDb ", data);
  // if signed out  i.e false
  if (!data.signedIn) {
    return "AUTH_ACTIONS.SUSPECT";
  }
};
export const setDbFields = async (uid, fields) => {
  await db.ref("/users/" + uid).set(fields);
};

export const getDbFields = async uid => {
  const ref = await db.ref("/users/" + uid).once("value");
  const data = ref.val();
  return data;
};

export const forceLogin = async () => {
  const uid = firebase.auth().currentUser.uid;
  const email = localStorage.getItem("email");

  console.log(" in forece login email ", email, " uid ", uid);
  // logout-->all other devices will be loged out
  await setDbFields(uid, { email, signedIn: false });
  // wait for sometime( more than watchingFrequencyTime )..so that other user will receive notification ( watchDb will be called within watchingFrequencyTime)
  sleep(watchingFrequencyTime + 1000);
  // login--
  await setDbFields(uid, { email, signedIn: true });
  console.log(await getDbFields(uid), " in firebase");
};

export const sleep = miliseconds => {
  var currentTime = new Date().getTime();
  while (currentTime + miliseconds >= new Date().getTime()) {}
};



// WEBPACK FOOTER //
// ./src/firebase/index.js